import { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";
import Slider from "@mui/material/Slider";
import { DataContext } from "src/contexts/DataContext";
import { TimingContext } from "src/contexts/TimingContext";
import "./timeselection.css";
import { DepthChart } from "../depth-graph/depth-graph";
import { EDFGraph } from "../edf-graph";
import { speedOptions } from "src/contexts/initData";
import { GraphHoverProvider } from "src/contexts/GraphHoverContext";

function SliderControls() {
  const { playing, setPlaying, speed, setSpeed } = useContext(TimingContext);

  const handleSpeedChange = () => {
    const index = speedOptions.indexOf(speed);
    const nextIndex = (index + 1) % speedOptions.length;
    setSpeed(speedOptions[nextIndex]);
  };

  return (
    <div className="slider-controls">
      <div>{speed}x</div>
      <img
        onClick={() => setPlaying(!playing)}
        alt="play/pause"
        src={
          playing
            ? "images/slider-controls/material-symbols_pause.png"
            : "images/slider-controls/ph_play-fill.png"
        }
      />
      <img
        alt="change speed"
        onClick={handleSpeedChange}
        src={"images/slider-controls/ri_speed-fill.png"}
      />
    </div>
  );
}

export default function TimeSelection() {
  const { data, window, setWindow: setTimeWindow } = useContext(DataContext);
  const [localWindow, setLocalWindow] = useState<[number, number]>();

  useEffect(() => {
    if (!data) return;
    setLocalWindow([0, data.length]);
  }, [data]);

  useEffect(() => {
    if (!window || !data.length) return;
    const startIndex =
      data.find((d) => dayjs(d.time).isSame(window[0], "minute"))?.idx ?? 0;
    const endIndex =
      data.find((d) => dayjs(d.time).isSame(window[1], "minute"))?.idx ??
      data.length;
    setLocalWindow([startIndex, endIndex]);
  }, [window, data]);

  if (!window) return <></>;
  if (data.length === 0) return <></>;

  const handleChange = (event, newValue) => {
    const new_data = data
      .filter((d) => d.idx >= (newValue[0] < 0 ? 0 : newValue[0]))
      .filter(
        (d) =>
          d.idx <=
          (newValue[1] > data.length - 1 ? data.length - 1 : newValue[1])
      );

    if (new_data.length > 10) {
      const d0 = new_data.at(0)["R_Time"];
      const d1 = new_data.at(new_data.length - 1)["R_Time"];

      setLocalWindow(newValue);
      setTimeWindow([d0, d1]);
    }
  };

  if (!data.length) return <></>;

  return (
    <div className="panel bottom-center">
      <GraphHoverProvider>
        <div id="time-selection-container">
          <SliderControls />
          <Slider
            className="slider"
            min={0}
            max={data.length}
            getAriaLabel={() => "Range"}
            value={localWindow}
            onChange={handleChange}
            valueLabelDisplay="auto"
          />
        </div>
        <DepthChart />
        <EDFGraph />
      </GraphHoverProvider>
    </div>
  );
}
